import { SearchIcon } from "../../design-system";
import { TextInput, type TextInputProps } from "./TextInput";

export type SearchProps = Omit<TextInputProps, "type" | "iconLeft">;

export function Search({ "aria-label": ariaLabel, ...props }: SearchProps) {
  return (
    <TextInput
      {...props}
      type="search"
      aria-label={ariaLabel ?? "Search"}
      iconLeft={<SearchIcon />}
    />
  );
}
